export function isUrl(maybeAUrl: string) {
  try {
    new URL(maybeAUrl)
    return true
  } catch {
    return false
  }
}
